var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 8.60901C14.8284 8.60901 15.5 7.93744 15.5 7.10901C15.5 6.28058 14.8284 5.60901 14 5.60901C13.1716 5.60901 12.5 6.28058 12.5 7.10901C12.5 7.93744 13.1716 8.60901 14 8.60901ZM14.8904 1.90373C14.361 1.51338 13.6392 1.51337 13.1098 1.90371L3.61069 8.90855C2.44554 9.76775 3.05326 11.6158 4.50094 11.6158H5V18.8581C3.82552 19.3479 3 20.507 3 21.859V23.359C3 23.7732 3.33579 24.109 3.75 24.109H24.25C24.6642 24.109 25 23.7732 25 23.359V21.859C25 20.507 24.1745 19.3479 23 18.8581V11.6158H23.4988C24.9465 11.6158 25.5542 9.76778 24.3891 8.90857L14.8904 1.90373ZM6.5 18.609V11.6158H9V18.609H6.5ZM21.5 11.6158V18.609H19V11.6158H21.5ZM17.5 11.6158V18.609H14.75V11.6158H17.5ZM13.25 11.6158V18.609H10.5V11.6158H13.25ZM4.50094 10.1158L14.0001 3.11096L23.4988 10.1158H4.50094ZM4.5 21.859C4.5 20.8925 5.2835 20.109 6.25 20.109H21.75C22.7165 20.109 23.5 20.8925 23.5 21.859V22.609H4.5V21.859Z",
    fill: "#237FFF",
    stroke: "#237FFF",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankBlue);
export default __webpack_public_path__ + "static/media/bank-blue.688a006f706ddb134fcb4c61432652d8.svg";
export { ForwardRef as ReactComponent };